import Vue from 'vue';

export default Vue.component('PrismCode', {
   props: {
      code: {
         type: String,
         default: '',
      },
      language: {
         type: String,
         default: 'markup',
      },
      lines: {
         type: Boolean,
         default: true,
      },
   },
   render(createElement) {
      const languageClass = `language-${this.language}`;
      return createElement(
         'pre',
         {
            class: `${this.lines ? 'line-numbers' : ''} ${languageClass}`,
         },
         [
            createElement('code', {
               class: languageClass,
               domProps: { textContent: this.code },
            }),
         ]
      );
   },
});
